import { Component, OnInit, AfterViewInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { AuditService, OrderTypeConfig, StoreConfig } from 'ngx-web-api';
import { UiOrchestratorService } from '../../core/services/ui-orchestrator.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderTypeModalContext } from 'app/domain/order-type-modal-context';
import { FocusService } from 'app/focus.service';

@Component({
  selector: 'fts-order-type-modal',
  templateUrl: './order-type-modal.component.html',
  styleUrls: ['./order-type-modal.component.scss'],
})
export class OrderTypeModalComponent implements OnInit, AfterViewInit, OnDestroy {
  public context: OrderTypeModalContext;
  store: StoreConfig;
  orderTypes: OrderTypeConfig[];

  @ViewChild('modalContent', { static: false })
  private modalContent: ElementRef;

  constructor(
    private auditService: AuditService,
    private uiOrchestratorService: UiOrchestratorService,
    private activeModal: NgbActiveModal,
    private focusService: FocusService
  ) {}

  ngOnInit() {
    this.store = this.context.store;
    this.orderTypes = this.context.orderTypes;
    this.auditService.createAudit(() => `Order Type modal has been opened`);
    this.uiOrchestratorService.informModalOpened();
    this.setAppWrapperInert(true);
  }

  ngAfterViewInit() {
    // Activate focus trap on modal to prevent focus from escaping
    setTimeout(() => {
      if (this.modalContent?.nativeElement) {
        this.focusService.activateFocusTrap(this.modalContent.nativeElement);
        this.modalContent.nativeElement.focus();
      }
    });
  }

  ngOnDestroy() {
    this.focusService.deactivateFocusTrap();
    this.setAppWrapperInert(false);
  }

  private setAppWrapperInert(inert: boolean) {
    const appWrapper = document.getElementById('ftsRootAppWrapper');
    if (appWrapper) {
      if (inert) {
        appWrapper.setAttribute('inert', '');
        appWrapper.setAttribute('aria-hidden', 'true');
      } else {
        appWrapper.removeAttribute('inert');
        appWrapper.removeAttribute('aria-hidden');
      }
    }
  }

  handleCancel(): void {
    this.activeModal.close(false);
  }

  handleOrderInitialized() {
    this.activeModal.close(true);
  }
}
